import { useContext } from 'preact/hooks'
import cn from 'classnames'
import { Recovery } from '../index'
import styles from './Button.module.css'

const Button = ({ name, onClick }) => {
  const { isLoading } = useContext(Recovery)
  return (
    <button
      className={cn(styles.button, { [styles.button_wait]: isLoading })}
      onClick={onClick}
    >
      {name}
    </button>
  )
}

export default Button
